import { Media } from '@/components/primitives/Media';

import styles from './BackgroundVideo.module.css';

import type { BackgroundVideoPoster as BackgroundVideoPosterConfig } from './backgroundVideo.shared';

type BackgroundVideoPosterProps = BackgroundVideoPosterConfig & {
  hidden?: boolean;
};

export function BackgroundVideoPoster({
  sources,
  formats,
  alt,
  width = 1920,
  height = 1080,
  sizes = '100vw',
  hidden = false,
}: BackgroundVideoPosterProps) {
  return (
    <Media
      className={[styles.poster, hidden ? styles.posterHidden : ''].filter(Boolean).join(' ')}
      sources={sources}
      formats={formats}
      sizes={sizes}
      alt={alt}
      loading="eager"
      decoding="async"
      width={width}
      height={height}
    />
  );
}
